import styled from 'styled-components';

import { bidiText } from 'components/bidi';

import { ctrlBase, fieldContainer, fieldLabel, fieldMessage } from '../base';

export const inputContainer = styled.div`
  ${fieldContainer}
`;

export const Input = styled('input')`
  ${ctrlBase}
  padding-right: var(--s6);
  cursor: pointer;

  &.mini {
    height: var(--h-btn-sm);
    font-size: var(--fs-label);
  }
`;

export const Label = styled('label')<{ labelColor?: string | undefined }>`
  ${fieldLabel}

  &.mini {
    font-weight: var(--fw-regular);
  }
`;

export const message = styled.span`
  ${fieldMessage}
`;

export const icon = styled.div`
  position: absolute;
  right: var(--s3);
  bottom: 0;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--text-muted);
  line-height: 0;
  pointer-events: none;

  &.mini {
    right: var(--s2);
  }
`;

export const iconSelect = styled.div`
  position: absolute;
  left: var(--s3);
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

/*
 * The closed list still occupies the DOM so that max-height can animate.
 * At max-height 0 the box collapses to nothing but its own border, which the
 * browser still paints — a 2px grey rule the width of the field, sitting a
 * --s1 gap below it. That was the stray underline under every DropDown.
 * The panel's surface is therefore drawn only while it is open.
 */
export const dropDownItems = styled.ul`
  width: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: var(--surface);
  border: 1px solid transparent;
  border-radius: var(--r-md);
  list-style: none;
  position: absolute;
  top: calc(100% + var(--s1));
  max-height: 0;
  visibility: hidden;
  transition: max-height 0.2s;
  padding: 0;
  z-index: var(--z-overlay);

  &.show {
    max-height: var(--h-overlay-max);
    visibility: visible;
    border-color: var(--line);
    box-shadow: var(--sh-2);
  }
`;

/* Option labels are payload — category titles, menu items, floor names. */
export const dropDownItem = styled.li`
  ${bidiText};
  padding: 0 var(--s3);
  min-height: var(--h-ctrl);
  display: flex;
  align-items: center;
  gap: var(--s2);
  border-bottom: 1px solid var(--line);
  cursor: pointer;
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
  color: var(--text);

  &.active-check {
    padding-left: var(--s6);
  }

  &:last-child {
    border-bottom: none;
  }

  &.active {
    background: var(--primary-soft);
    color: var(--primary);
    font-weight: var(--fw-medium);
    padding-left: var(--s3);
  }

  &:hover {
    background: var(--surface-alt);
  }
`;

export const text = styled.span`
  ${bidiText};
  font-size: var(--fs-body);
  font-weight: var(--fw-regular);
`;

export const img = styled.img``;

export const arrowImg = styled.img``;

export const InputBox = styled.div`
  position: relative;
`;
